<!--  this template used to show product details and ability to add item to the basket-->

<div id="selectedProduct" class="modal modal-dialog-scrollable select-product-modal" [ngStyle]="{ display: 'none' }">
    <div class="modal-content">
    <div class="modal-header" [ngStyle]="{
            'justify-content': 'right',
            height: '40px',
            backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
            'border-bottom': borderStyle,
          }">
        <a (click)="productCancelClicked()" id="btnnotification" class="close-icon">
            <i [ngStyle]="{
                color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
              }" class="zmdi zmdi-close zmdi-hc-fw"></i>
        </a>
    </div>
    <div #scrollDiv class="modal-body scroll-container">
        <!-- <button type="button" class="close" >
                <span class="zmdi zmdi-info zmdi-hc-lg"></span>
            </button>  -->
    <div class="scrollbar-placeholder"></div>
    <div class="scrollbar-placeholder-thumb"></div>
    {{ pageModel.selectedProduct }}
    @if (
    (Merchant$ | async)?.webapp_settings?.show_product_image &&
    product?.images?.length > 0
    ) {
    <div class="single-img mb-4 text-center">
        <img src="{{ pageModel?.selectedProduct?.product_image }}" />
        <!-- <img src="{{pageModel.selectedProduct?.images[0]?.url}}" /> -->
        </div>
        }
        <div class="justify-content-center box">
        <h2 class="h6 allow-break-line" [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings
              ?.menu_font_color_allpage,
          }"
          [innerHTML]="
            pageModel.selectedProduct === null
              ? ''
              : pageModel.selectedProduct?.name
          "
        >
          {{ pageModel?.selectedProduct?.name }}
        </h2>
        <p
          class="mt-2 mb-0 allow-break-line"
          [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings
              ?.menu_font_color_allpage,
            'max-height':
              (Merchant$ | async)?.webapp_settings?.show_product_image &&
              product?.images?.length > 0
                ? '120px'
                : '80%',
            overflow: 'auto',
            'white-space': 'break-spaces',
          }"
          [innerHTML]="product?.product_additional_info"
        ></p>
        <p
          class="h5 text-muted mb-3"
          ngClass="{{
            pageModel.selectedProduct?.is_discount ? 'strikethrough' : ''
          }}"
        >
          {{ (Merchant$ | async)?.currency }}
          <span class="notranslate">
            {{
              pageModel.selectedProduct === null
                ? ""
                : (pageModel.selectedProduct?.price *
                    pageModel.selectedProduct?.quantity | currencyFormat: (Merchant$ | async)?.currency_decimals)
            }}</span
          >
        </p>
        @if (pageModel.selectedProduct?.is_discount) {
          <p class="h5 text-muted mb-3">Discounted price</p>
        }
        @if (pageModel.selectedProduct?.is_discount) {
        <p ngClass="" class="h5 text-muted mb-3">
            {{ (Merchant$ | async)?.currency }}
            <span class="notranslate">{{
                pageModel.selectedProduct === null
                ? ""
                : (pageModel.selectedProduct?.discounted_price *
                pageModel.selectedProduct?.quantity | currencyFormat: (Merchant$ | async)?.currency_decimals)
                }}</span>
        </p>
        }
    </div>

    @if (!isInfoPopup) {
    @if (pageModel.selectedProduct?.attribute_details?.length > 0) {
    <div class="row row-cols-2 mb-4">
        <div class="col-12">
            <div class="form-group">
                <label class="text-primary allow-break-line" [innerHTML]="pageModel.firstVariantName"></label>
                <ng-select class="ngselect2-modal" bindLabel="value" [items]="pageModel.firstVariantOptions"
                    [(ngModel)]="pageModel.firstSelectedVariant" (change)="GetValue(1)" placeholder="-- Select --">
                </ng-select>
                </div>
                </div>
                @if (pageModel.hideSecondattr) {
                <div class="col-12">
                    <div class="form-group">
                <label class="text-primary allow-break-line" [innerHTML]="pageModel.secondVariantName"></label>
                <ng-select class="ngselect2-modal" bindLabel="value" [items]="pageModel.secondVariantOptions"
                    [(ngModel)]="pageModel.secondSelectedVariant" (change)="GetValue(2)" placeholder="-- Select --">
                </ng-select>
                </div>
                </div>
                }
                </div>
                }
                @if (!pageModel.selectedProduct?.is_mix_and_match_eligible) {
                <div class="row row-cols-3">
                    <div class="col d-grid">
            <button class="btn btn-grey-theme btn-lg" (click)="UpdateProductQuantity(1)">
                <i class="zmdi zmdi-minus zmdi-hc-lg"></i>
            </button>
            </div>
            <div class="col d-grid">
            <p ngClass="" class="text-muted h5 m-1 text-center btn qty btn-lg" translate="no">
                <span>X {{ pageModel.selectedProduct?.quantity }}</span>
            </p>
            </div>
            <div class="col d-grid">
            <button class="btn btn-grey-theme btn-lg" (click)="UpdateProductQuantity(2)">
                <i class="zmdi zmdi-plus zmdi-hc-lg"></i>
            </button>
            </div>
            </div>
            }
            }
            </div>
    @if (!isInfoPopup) {
    <div class="modal-footer" [ngStyle]="{ display: 'block' }">
        <!-- <div class="col m-0 d-grid">
                <button type="button"
                    [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,'backgroundColor':(Merchant$ | async)?.webapp_settings?.menu_color,'border' :borderStyle}"
                    class="btn btn-orange-light-theme btn-lg font-size-15" (click)="productCancelClicked()">
                    Cancel</button>
            </div> -->
        <div class="d-grid">
            <!-- (click)="modal.close('Close click')" -->
        <button type="button" [ngStyle]="{
                      color: (Merchant$ | async)?.webapp_settings
                        ?.menu_font_color_homepgae,
                      backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                      border: borderStyle,
                    }" class="btn btn-orange-light-theme btn-lg font-size-15 mt-2"
            (click)="ValidateLogin(pageModel.selectedProduct.id, loginModel)"
          >
            Add
          </button>
        </div>
      </div>
    } @else {
    <div class="modal-footer" [ngStyle]="{ display: 'block' }">
        <div class="d-grid">
        <button id="btnCancel" class="btn btn-orange-light-theme btn-lg font-size-15 mt-2" [ngStyle]="{
                      color: (Merchant$ | async)?.webapp_settings
                        ?.menu_font_color_homepgae,
                      backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                      border: borderStyle,
                    }" (click)="infoPopupClose()">
            OK
        </button>
        </div>
    </div>
    }
    </div>
</div>

<ng-template #loginModel let-model>
<!-- Modal content -->
<div class="modal-header" [ngStyle]="{
      'justify-content': 'right',
      height: '40px',
      backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
      'border-bottom': borderStyle,
    }">
    <a (click)="model.close()" id="btnnotification" class="close-icon">
        <i [ngStyle]="{
          color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
        }" class="zmdi zmdi-close zmdi-hc-fw"></i>
    </a>
</div>
<div class="modal-body">
    <p [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings?.menu_font_color_allpage,
          }" id="textcontent">
        <span>To create an order please click CONTINUE and register and/or sign in
            first. If you wish to continue browsing please click CANCEL .</span>
    </p>
    </div>
    <div class="modal-footer justify-content-center">
    <button id="btnclosepop" [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
            backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
            border: borderStyle,
          }" (click)="RedirectToLogin(); model.close()">
        CONTINUE
    </button>
    <!-- <button id="btnclose"
            [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,'backgroundColor':(Merchant$ | async)?.webapp_settings?.menu_color,'border' :borderStyle}"
            (click)="model.close();"> CANCEL</button> -->
</div>
</ng-template>

<!--  this div used to show  mix&match schema so user can from the list -->
<ng-template #mixmatchSelection let-modal>
<!-- Modal content -->
<div class="modal-header" [ngStyle]="{
      'justify-content': 'right',
      height: '40px',
      backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
      'border-bottom': borderStyle,
    }">
    <a (click)="closemixMatch()" id="btnnotification" class="close-icon">
        <i [ngStyle]="{
          color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
        }" class="zmdi zmdi-close zmdi-hc-fw"></i>
    </a>
</div>
<div class="modal-body">
    <div>
        If you want to make the most of our multipack pricing, you must select
        your desired multipack from the options below. If you do not select your
        multipack option here, the discount will not be applied. Feel free to mix
        and match across any of the applicable ranges.
        @for (item of mixandmatchlist; track item) {
        <p [ngStyle]="{
                color: (Merchant$ | async)?.webapp_settings
                  ?.menu_font_color_allpage,
              }" style="margin-bottom: 0" id="textcontent">
            <a style="cursor: pointer; text-decoration: underline" (click)="AddMixAndMatch(item)">{{ item.description }}</a>
        </p>
        }
    At checkout we will cross-check if you have fulfilled the mix & match
    quota for selected scheme and give you the option to go back to add
    additional product to fill the quota)
    </div>
    </div>
<div class="modal-footer" style="justify-content: center">
    <!-- <button
            [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,'backgroundColor':(Merchant$ | async)?.webapp_settings?.menu_color,'border' :borderStyle}"
            (click)="closemixMatch()">Cancel</button> -->
</div>
</ng-template>

<!--  this div used to show  extra product details and ability to add extra item to the basket-->
<app-messagepopup></app-messagepopup>

<div id="stockLimitModal" class="modal" [ngStyle]="{ 'z-index': 6 }">
    <!-- Modal content -->
    <div class="modal-content">
    <div class="modal-header" [ngStyle]="{
            'justify-content': 'right',
            height: '40px',
            backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
            'border-bottom': borderStyle,
          }">
        <a (click)="closeStockLimit()" id="btnnotification" class="close-icon">
            <i [ngStyle]="{
                color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
              }" class="zmdi zmdi-close zmdi-hc-fw"></i>
        </a>
    </div>
    <div class="modal-body">
        <div class="col">
            <div class="stock-warning">
                <div class="stock-message">
            {{ stockLimitText }}
            </div>
            <div class="stock-note">
            {{ stockLimitNoteText }}
            </div>
            </div>
    </div>
    <div class="modal-footer" [ngStyle]="{ display: 'block' }">
        <div class="d-grid">
        <button type="button" [ngStyle]="{
                      color: (Merchant$ | async)?.webapp_settings
                        ?.menu_font_color_homepgae,
                      backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                      border: borderStyle,
                    }" class="btn btn-accent-theme btn-lg mt-2" (click)="adjustStockLimit()">
            Adjust
        </button>

        <!-- <button type="button"
                        [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,'backgroundColor':(Merchant$ | async)?.webapp_settings?.menu_color,'border' :borderStyle}"
                        class="btn btn-accent-theme btn-lg mt-2" (click)="closeStockLimit();">Cancel</button> -->
        </div>
        </div>
        </div>
</div>
</div>

<app-extraproduct [currentBasketItems]="currentBasketItems" [ProductQtyId]="ProductQtyId"
    [tempProductId]="tempProductId" (closeExtra)="closeExtra()" [pageModel]="pageModel"></app-extraproduct>

<app-popup-login (CloseLoginPopup)="closeLogin()" [ShowLogin]="showLogin"></app-popup-login>

<div id="registerModal" class="modal" [ngStyle]="{ 'z-index': 6 }">
    <!-- Modal content -->
    <div class="modal-content">
    <div class="modal-header" [ngStyle]="{
            'justify-content': 'right',
            height: '40px',
            backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
            'border-bottom': borderStyle,
          }">
        <a (click)="closeRegistration()" id="btnnotification" class="close-icon">
            <i [ngStyle]="{
                color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
              }" class="zmdi zmdi-close zmdi-hc-fw"></i>
        </a>
    </div>
    <div>
    @if (registerPopup) {
    <app-popup-register (ClosePopup)="closeRegistration()"></app-popup-register>
    }
    </div>
    </div>
</div>

<div id="loginOptions" class="modal" [ngStyle]="{ 'z-index': 5 }">
    <!-- Modal content -->
    <div class="modal-content">
    <div class="modal-header" [ngStyle]="{
            'justify-content': 'right',
            height: '40px',
            backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
            'border-bottom': borderStyle,
          }">
        <a (click)="cancelClicked()" id="btnnotification" class="close-icon">
            <i [ngStyle]="{
                color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
              }" class="zmdi zmdi-close zmdi-hc-fw"></i>
        </a>
    </div>
    <div class="modal-body">
    <p [ngStyle]="{
              color: (Merchant$ | async)?.webapp_settings?.menu_font_color_allpage,
            }">
        <span>Almost done! To place your order, sign in or create a toodle account.
            Your account works across the entire toodle ecosystem, making it easy
            to access features and potential promotions from any toodle
            merchant.</span>
    </p>
    </div>
    <div class="modal-footer" [ngStyle]="{ display: 'block' }">
        <div class="d-grid">
        <button id="btnLogin" class="btn btn-orange-light-theme btn-lg font-size-15" [ngStyle]="{
                    color: (Merchant$ | async)?.webapp_settings
                      ?.menu_font_color_homepgae,
                    backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                    border: borderStyle,
                  }" (click)="redirectToLogin()">
            Login
        </button>
        <button id="btnCreateAccount" class="btn btn-orange-light-theme btn-lg font-size-15 mt-2" [ngStyle]="{
                    color: (Merchant$ | async)?.webapp_settings
                      ?.menu_font_color_homepgae,
                    backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                    border: borderStyle,
                  }" (click)="redirectToCreateAccount()">
            Create account
        </button>
        @if ((Merchant$ | async)?.webapp_settings?.guest_access_allowed) {
        <button id="btnGuest" class="btn btn-orange-light-theme btn-lg font-size-15 mt-2" [ngStyle]="{
                      color: (Merchant$ | async)?.webapp_settings
                        ?.menu_font_color_homepgae,
                      backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                      border: borderStyle,
                    }" (click)="proceedAsGuest()">
            Proceed as guest
        </button>
        }

        <!-- <button id="btnCancel" class="btn btn-orange-light-theme btn-lg font-size-15 mt-2"
                    [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,'backgroundColor':(Merchant$ | async)?.webapp_settings?.menu_color,'border' :borderStyle}"
                    (click)="cancelClicked();">Cancel</button> -->
    </div>
    </div>
    </div>
</div>

<div id="additionalInformationModal" style="display: none" class="modal" [ngStyle]="{ 'z-index': 5 }">
    <!-- Modal content -->
    <div class="modal-content">
    <div class="modal-header" [ngStyle]="{
            'justify-content': 'right',
            height: '40px',
            backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
            'border-bottom': borderStyle,
          }">
        <a (click)="closeAdditionalInfo()" id="btnnotification" class="close-icon">
            <i [ngStyle]="{
                color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
              }" class="zmdi zmdi-close zmdi-hc-fw"></i>
        </a>
    </div>
    <div class="modal-body">
    <div>
        @if (pageModel?.selectedProduct?.is_special_instruction == 1) {
        <label class="m-1">If applicable, enter additional information for this item.</label><br />
        <!-- <input class="m-1" style="height: 31px; width: 90%" type="text" [(ngModel)]="pageModel.productText" /> -->
         <textarea class="m-1" style="width: 100%" type="text" [(ngModel)]="pageModel.productText"
          cdkAutosizeMinRows="6"></textarea>
        }
        @if (pageModel?.selectedProduct?.is_image_upload_instruction == 1) {
        <label class="form-label">
          Upload an image for this item <span class="text-danger">*</span>
          <small class="text-muted">(JPEG, PNG, WebP · Max 2 MB)</small>
        </label>

        <input class="m-1" type="file" accept="image/jpeg,image/png,image/gif,image/webp" (change)="onImageUpload($event)" />
        @if (pageModel.productImage) {
        <div class="m-1">
            <img [src]="pageModel.productImage" style="max-width: 100%; max-height: 200px; margin-top: 10px;" />
            <button class="btn btn-sm btn-danger m-1" (click)="removeImage()">Remove</button>
        </div>
        }
        }
        </div>
        </div>
    <div class="modal-footer" [ngStyle]="{ display: 'block' }">
        <div class="d-grid">
            <!-- <button id="btnLogin" class="btn btn-orange-light-theme btn-lg font-size-15"
          [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,'backgroundColor':(Merchant$ | async)?.webapp_settings?.menu_color,'border' :borderStyle}"
          (click)="redirectToLogin(); ">Login</button>
        <button id="btnCreateAccount" class="btn btn-orange-light-theme btn-lg font-size-15 mt-2"
          [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,'backgroundColor':(Merchant$ | async)?.webapp_settings?.menu_color,'border' :borderStyle}"
          (click)="redirectToCreateAccount();">Create account</button>
        @if((Merchant$ | async)?.webapp_settings?.guest_access_allowed){

        <button id="btnGuest" class="btn btn-orange-light-theme btn-lg font-size-15 mt-2"
          [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,'backgroundColor':(Merchant$ | async)?.webapp_settings?.menu_color,'border' :borderStyle}"
          (click)="proceedAsGuest();">Proceed as guest</button>
        } -->

        <button id="btnCancel" class="btn btn-orange-light-theme btn-lg font-size-15 mt-2" [ngStyle]="{
                    color: (Merchant$ | async)?.webapp_settings
                      ?.menu_font_color_homepgae,
                    backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                    border: borderStyle,
                  }" [disabled]="isImageUploading" (click)="
                    AddProductToBasket(pageModel?.selectedProduct?.id, loginModel)
                  ">
            @if (isImageUploading) {
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            }
            {{ isImageUploading ? 'Uploading...' : 'Proceed' }}
        </button>
        </div>
    </div>
    </div>
</div>

<!-- Getting Guest user details as per the webapp setting flag if flag on then it will required -->
<app-guestlogin [currentMerchant]="currentMerchant" (GuestLoginChange)="Guestlogin($event)"
    [GuestLogin]="GuestLogin"></app-guestlogin>